import { render, staticRenderFns } from "./MypageSettings.vue?vue&type=template&id=6b8c9222&scoped=true"
import script from "./MypageSettings.vue?vue&type=script&lang=js"
export * from "./MypageSettings.vue?vue&type=script&lang=js"
import style0 from "./MypageSettings.vue?vue&type=style&index=0&id=6b8c9222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c9222",
  null
  
)

export default component.exports